export function canViewDonationOnboardingRequirements({
  deliveryOption,
  isRecipientTeam,
  canClaimDonation,
}) {
  if (deliveryOption === 'STAFF-MEALS') {
    return false;
  }

  return isRecipientTeam || canClaimDonation;
}
